import React, { useEffect, useRef, useState } from "react";

type ProgressBarProps = {
  autoCloseTimer: number; // in seconds
  resetKey?: string | number;
};

const ToastProgressBar: React.FC<ProgressBarProps> = ({
  autoCloseTimer,
  resetKey,
}) => {
  const barRef = useRef<HTMLDivElement>(null);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    const bar = barRef.current;
    if (!bar) return;

    // Step 1: Immediately reset to full width without transition
    setIsAnimating(false);
    bar.style.transform = "scaleX(1)";
    bar.style.transition = "none";

    // Step 2: Force reflow to apply transform immediately
    void bar.offsetWidth;

    // Step 3: Enable transition and start animating
    setIsAnimating(true);
    bar.style.transition = `transform ${autoCloseTimer}s linear`;
    bar.style.transform = "scaleX(0)";

    // Cleanup transition on unmount
    return () => {
      bar.style.transition = "none";
    };
  }, [autoCloseTimer, resetKey]);

  return (
    <div
      style={{
        width: "100%",
        height: "10px",
        backgroundColor: "#ddd",
        borderRadius: "4px",
        overflow: "hidden",
      }}
    >
      <div
        ref={barRef}
        style={{
          width: "100%",
          height: "100%",
          backgroundColor: "#f97316",
          transformOrigin: "left",
          transform: "scaleX(1)",
        }}
      />
    </div>
  );
};

export default ToastProgressBar;
